import { ArticleLayout } from "types/api";
import { ArticleRenderNotSupported } from "./error";

export default function checkArticleRenderSupport({
  article: { isTnfCompatible },
}: {
  article: { layout: ArticleLayout; isTnfCompatible: boolean };
}) {
  if (!isTnfCompatible) {
    throw new ArticleRenderNotSupported();
  } else {
    return;
  }
}
